import { Part, tKeyType } from '@/Engine/Part';
import { $ } from '@/Engine/state';
import { tParentAccessory } from '@/Interfaces/caseComponentsLib';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { setPositionForAccessory } from '@/Engine/eventHandlers/libs/setPositionForAccessory';

export function childrenAccessoryWithoutAccessory(activeComponent: Part, parentKeys: tParentAccessory[]) {
    if (!$.toolChest) return;
    for (const key of parentKeys) {
        if (!$.toolChest[key]) continue;
        $.toolChest[key]
            .filter(x => x.childrenAccessory.includes(activeComponent))
            .filter(x => {
                x.childrenAccessory = x.childrenAccessory.filter(x => x !== activeComponent);
            });
    }
}
export function setAccessoryChildrenParent() {
    if (!$.toolChest) return;
    initRelationShieldsWithAccessories();
}

//getMaxItemsByPositionAndScale - группировка переданных экрнов по принципу
//среди наложенных друг на друга оставляем самые приоритетные(верхние) чтобы у стопки экранов был актуален только один
//не наложенные просто возвращаем
function getMaxItemsByPositionAndScale(items: Part[]) {
    const groups = {};
    items.forEach(item => {
        const key = `${item.position.y}_${item.scale.x}`;
        if (!groups[key]) {
            groups[key] = [];
        }
        groups[key].push(item);
    });

    const result = [];
    Object.values(groups).forEach(group => {
        const maxItem = group.reduce((acc, cur) => {
            return cur.isPriorityIndex > acc.isPriorityIndex ? cur : acc;
        });
        result.push(maxItem);
    });

    return result;
}


export function getActualParent(accessory: Part, parentKeys: tParentAccessory[]) {
    if (!$.toolChest) return;
    const result: Part[] = [];
    let typeParent: tKeyType|undefined;
    for (const key of parentKeys) {
        if (!$.toolChest[key]) continue;
        for (const item of $.toolChest[key]) {
            if (!item.obb || !accessory.obb) continue;
            if ((!typeParent || typeParent === item.key) && item.obb.intersectsOBB(accessory.obb)) {
                result.push(item);
                typeParent = item.key;
            }
        }
    }
    if (!typeParent) return;
    //  условия актуальности:
    //  1 может быть несколько родителей когда аксессуар на стыке двух экранов
    //  2 может быть наложение экранов тогда самый приоритетынй(верхний) экран актуален
    //  3 не обязательно у всех родителей одного ребенка одинаковый приоритет (если аксессуар закреплен на 2х родителях пример - 1) один экран 2) два друг на друге)
    return $.toolChest[typeParent].filter(item => getMaxItemsByPositionAndScale(result).includes(item));
}

export function setActualParentChildren(accessory: Part, parentKeys: tParentAccessory[]) {
    //получение актуальных родителей
    const actualParents = getActualParent(accessory, parentKeys);
    actualParents?.forEach(item => item.childrenAccessory.push(accessory));
    //взаимооднозначное соответсвтие детей и родителей
    accessory.parentAccessory = [];
    actualParents?.forEach(item => {
        if (item.childrenAccessory.includes(accessory)) {
            accessory.parentAccessory?.push(item);
        }
    });
}
export const initRelationShieldsWithAccessories = () => {
    if (!$.toolChest) return;
    $.toolChest.shield?.forEach(x => x.childrenAccessory = []);
    $.toolChest.accessory?.forEach(x => x.parentAccessory = []);
    let isUpdate = false;
    for (const accessory of $.toolChest.accessory) {
        setActualParentChildren(accessory, [ 'shield', 'shelf' ]);
        if (accessory.isPlasticBoxWithParentShield()) {
            $.toolChest.createHolder(accessory);
            isUpdate = true;
        }
        if (accessory.isPlasticBoxWithParentShelf()) {
            setPositionForAccessory(accessory);
            isUpdate = true;
        }
    }
    if (isUpdate) {
        useStoreCaseConfiguration().$patch({ caseItems: $.toolChest.raw.caseItems });
    }
};